












import Vue from 'vue';
export default Vue.extend({
  name: 'TextareaGroup',

  model: {
    prop: 'textareaValue',
    event: 'change'
  },

  props: {
    label: {
      type: String,
      required: false
    },
    textareaValue: {
      type: String
    }
  },

  data: () => {
    return {
      id: ''
    };
  },

  created() {
    this.id = `form-group-${this._uid}`;
  }
});
